<!-- Zone 1 redesign (29/10/2026): the picture first, because it explains the
     request faster than the text; then one title, one sentence, and the
     privacy promise behind a lock. « Plus tard » becomes a quiet text button,
     so the screen offers one clear action instead of two equal ones. -->
<ion-content class="ion-padding">
  <div class="modal-content">
    <div class="content">
      <div class="illustration-card">
        <img src="assets/images/access_user_nearby.png" alt="" />
      </div>

      <smatchy-title mode="start" class="fc-sheet-title">{{ titleKey | translate }}</smatchy-title>

      <p class="fc-subtitle">
        {{ (isOsUnavailableMode ? descriptionKey : 'LOCATION_PERMISSION_MODAL.DESCRIPTION_SHORT') | translate }}
      </p>

      @if (!isOsUnavailableMode) {
      <p class="privacy">
        <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
        {{ 'LOCATION_PERMISSION_MODAL.PRIVACY_SHORT' | translate }}
      </p>
      }
    </div>

    <div class="actions">
      <ion-button expand="block" class="primary-action" (click)="enableLocation()" [disabled]="isLoading">
        @if (isLoading) {
        <ion-spinner name="crescent"></ion-spinner>
        } @else {
        {{ primaryButtonKey | translate }}
        }
      </ion-button>
      <ion-button
        expand="block"
        fill="clear"
        class="secondary-action fc-quiet"
        (click)="dismiss()"
        [disabled]="isLoading"
      >
        {{ 'LOCATION_PERMISSION_MODAL.LATER' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>
